module.exports = __webpack_public_path__ + "img/marker_odp_stationnement-0.9e10b3a9.png";